import { ErrorBoundary } from "$components/error-boundary";
import { TabContent } from "$routes/patient/[:patientId]/_lib/invoices-v2/tab-content";

export const InvoicingTab: FC<{ patientId: string }> = ({ patientId }) => {
  return (
    <ErrorBoundary name="invoicing-tab">
      <TabContent patientId={patientId} />
    </ErrorBoundary>
  );
};
